module.exports = __webpack_public_path__ + "img/hieda no akyuu_sc1.8b5bef79.png";